interface IFilterItem {
    index?: number,
    filterName?: string,
    checked: boolean,
    dragable: boolean,
    disabled: boolean,
    label: string,
    bracketsStr?: string,
    splicingLabel?: string,
    toLabel?: string,
}

interface IFiltersTypes {
    tableName: string,
    tableFiltersList: IFilterItem[],
}

export const FiltersTypes: IFiltersTypes[] = [
    {
        tableName: 'transportScheduleSearchFilter',
        tableFiltersList: [{
            filterName: 'headerDate',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Header Date',
        }, {
            filterName: 'helperName',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Helper Name, Fin No., Order No.',
        }, {
            filterName: 'transportType',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Transport Type',
        }, {
            filterName: 'agency',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Agency',
        }, {
            filterName: 'orderStatus',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Order Status',
        }, {
            filterName: 'task',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Task',
        }, {
            filterName: 'taskStatus',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Task Status',
        }, {
            filterName: 'location',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Location',
        }, {
            filterName: 'ETATime',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'ETA Time',
        }, {
            filterName: 'specialRequests',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Special Requests',
        }, {
            filterName: 'orderVerified',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Order Verified',
        }],
    }, {
        tableName: 'bankStatementsSearchFilter',
        tableFiltersList: [{
            filterName: 'transactionId',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Transaction ID',
        }, {
            filterName: 'status',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Status',
        }, {
            filterName: 'date',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Date',
        }, {
            filterName: 'depositAmount',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Deposit Amount',
        }, {
            filterName: 'withdrawalAmount',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Withdrawal Amount',
        }, {
            filterName: 'detailsInfo',
            checked: true,
            dragable: true,
            disabled: false,
            label: 'Details Info',
        }],
    },
]
